<div class="app-content content" *ngIf="loadPage">
    <div class="content-wrapper">
      <div class="content-header row mb-1">
      </div>
      <div class="content-body">
        <div class="row">
          <div class="col-xl-3 col-lg-6 col-12">
            <div class="card pull-up">
              <div class="card-content">
                <div class="card-body card_padding">
                  <div class="media d-flex">
                    <div class="media-body text-left">
                      <h3 class="info text-bold-600">{{numeroVacantes?.num_vacantes}}</h3>
                      <h3 class="info text-bold-600" *ngIf="!numeroVacantes?.num_vacantes">No hay datos</h3>
                      <h4 class="text-bold-600">Vacantes / ofertas disponibles</h4>
                    </div>
                    <div>
                      <i class="la la-list-ul info font-large-2 float-right"></i>
                    </div>
                  </div>
                  <div class="mb-0 mt-1">

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-6 col-12">
            <div class="card pull-up">
              <div class="card-content">
                <div class="card-body card_padding">
                  <div class="media d-flex">
                    <div class="media-body text-left">
                      <h3 class="warning text-bold-600" *ngIf="salarioPromedio">${{salarioPromedio}}</h3>
                      <h3 class="warning text-bold-600" *ngIf="!salarioPromedio">No hay datos</h3>
                      <h4 class="text-bold-600">Salario promedio en ofertas</h4>
                    </div>
                    <div>
                      <i class="la la-money warning font-large-2 float-right"></i>
                    </div>
                  </div>
                  <div class="mb-0 mt-1">
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <div class="col-xl-3 col-lg-6 col-12">
            <div class="card pull-up">
              <div class="card-content">
                <div class="card-body card_padding">
                  <div class="media d-flex">
                    <div class="media-body text-left">
                      <h3 class="success text-bold-600">{{postulaciones?.aceptados_porcentaje}} %</h3>
                      <h3 class="success text-bold-600" *ngIf="!postulaciones.aceptados_porcentaje">No hay datos</h3>
                      <h4 class="text-bold-600">Egresados contactados</h4>
                    </div>
                    <div>
                      <i class="icon-user-follow success font-large-2 float-right"></i>
                    </div>
                  </div>
                  <div class="mb-0 mt-1">
                    <ngb-progressbar height="7px" width="100%" type="gradient-x-success" [value]=postulaciones?.aceptados_porcentaje></ngb-progressbar>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-6 col-12">
            <div class="card pull-up">
              <div class="card-content">
                <div class="card-body card_padding">
                  <div class="media d-flex">
                    <div class="media-body text-left">
                      <h3 class="danger text-bold-600">{{postulaciones?.rechazados_porcentaje}} %</h3>
                      <h3 class="danger text-bold-600" *ngIf="!postulaciones.rechazados_porcentaje">No hay datos</h3>
                      <h4 class="text-bold-600">Egresados rechazados</h4>
                    </div>
                    <div>
                      <i class="feather ft-phone-off danger font-large-2 float-right"></i>
                    </div>
                  </div>
                  <div class="mb-0 mt-1">
                    <ngb-progressbar height="7px" width="100%" type="gradient-x-danger" [value]=postulaciones?.rechazados_porcentaje></ngb-progressbar>
                  </div>
                </div>
              </div>
            </div>
          </div>
 
        </div>
        <div class="row">
          <div class="col-xl-6 col-lg-12 col-sm-12">
            <div class="card card bg-gradient-x-info pull-up">
              <div class="card-content">
                <div class="card-body card_padding">
                  <div class="media d-flex">
                    <div class="media-body text-left">
                      <h3 class="text-bold-600 white" *ngIf="contador>0">{{contador}}</h3>
                      <h3 class="text-bold-600 white" *ngIf="contador===0">No hay datos</h3>
                      <h4 class="text-bold-600 white">Egresados trabajando</h4>
                    </div>
                    <div>
                      <i class="icon-briefcase font-large-2 float-right white"></i>
                    </div>
                  </div>
                  <div class="mb-0 mt-1">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl-6 col-lg-12 col-sm-12">
            <div class="EmailRate pull-up">
            <m-card>
              <ng-container mCardHeaderTitle>
                <h4 class="text-bold-600">Porcentaje de postulaciones por género</h4>
              </ng-container>
              <ng-container mCardBody *ngFor="let item of postulacionGenero; let i = index;">
                <p class="text-bold-600">Hechas por {{item.descripcion}} <span class="float-right"><h4 class="text-bold-600">{{item.porcentaje}}%</h4></span></p>
                <ngb-progressbar height="7px" *ngIf="i===0" type="danger" [value]=item.porcentaje></ngb-progressbar>
                <ngb-progressbar height="7px" *ngIf="i===1" type="success" [value]=item.porcentaje></ngb-progressbar>
                <ngb-progressbar height="7px" *ngIf="i===2" type="warning" [value]=item.porcentaje></ngb-progressbar>
                <ngb-progressbar height="7px" *ngIf="i>2" type="primary" [value]=item.porcentaje></ngb-progressbar>
              </ng-container>
            </m-card>
          </div>
          </div>
 
        </div>
        <!--/ Basic Horizontal Timeline -->

        <div class="row">
          <div class="col-12 col-md-12">
            <div class="card pull-up">
              <div class="card-header">
                <h4 class="text-bold-600">Top especialidades más solicitadas</h4>
              </div>
              <div class="card-content collapse show" *ngIf="top3">
                <div class="card-body p-0">
                    <div class="table-responsive">
                    <table class="table mb-0">
                      <tbody *ngFor="let item of top3; let i = index;">
                        <tr>
                          <th scope="row" class="border-top-0">{{item.area}}</th>
                          <td class="border-top-0"><h4 class="text-bold-600">{{item.cantidad}}</h4></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
            
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="card">
               <section>
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <m-card>
                      <ng-container mCardHeaderTitle>
                        <h4 class="text-bold-600">Gráfico de demanda de habilidades socioemocionales</h4>
                      </ng-container>
                      <ng-container mCardBody>
                        <div class="z">
                          <div style="height: 350px;"><canvas id="habilidades"></canvas></div>
                        </div>
                       </ng-container>
                    </m-card>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <m-card>
                      <ng-container mCardHeaderTitle>
                        <h4 class="text-bold-600">Gráfico de demanda de habilidades técnicas</h4>
                      </ng-container>
                      <ng-container mCardBody>
                        <div class="z">
                          <div style="height: 350px;"><canvas id="conocimientos"></canvas></div>
                        </div>
                       </ng-container>
                    </m-card>
                  </div>
                </div>
              </section>
            </div>
          </div>
          </div>
        <div class="row">
          <div class="col-12">
            <div class="card">
               <section>
                    <m-card class="text-center">
                      <ng-container mCardHeaderTitle>
                        <h4 class="text-bold-600">Gráfico de sueldos promedio por área</h4>
                      </ng-container>
                      <ng-container mCardBody>
                          <canvas id="comparative"></canvas>
                      </ng-container>
                    </m-card>
              </section>
            </div>
          </div>
          </div>          
    </div>
  </div>